import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@shigo-ui/ui';

type DashboardPageFormWidth = 'md' | 'lg';

export interface DashboardPageFormBodyProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  children: ReactNode;
  title?: ReactNode | undefined;
  description?: ReactNode | undefined;
  width?: DashboardPageFormWidth | undefined;
}

export function DashboardPageFormBody({
  children,
  title,
  description,
  width = 'md',
  className,
  ...props
}: DashboardPageFormBodyProps) {
  return (
    <div
      data-slot="dashboard-page-form-body"
      {...props}
      className={cn(
        'mx-auto grid w-full min-w-0 gap-5 px-5 py-8',
        width === 'lg' ? 'max-w-5xl' : 'max-w-3xl',
        className,
      )}
    >
      {title || description ? (
        <div className="min-w-0 text-left">
          {title ? <h2 className="text-foreground text-base font-semibold">{title}</h2> : null}
          {description ? <p className="text-muted-foreground mt-1 text-sm">{description}</p> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}
